import { render, staticRenderFns } from "./transformerMap.vue?vue&type=template&id=99a3d4ca&scoped=true&"
import script from "./transformerMap.vue?vue&type=script&lang=js&"
export * from "./transformerMap.vue?vue&type=script&lang=js&"
import style0 from "./transformerMap.vue?vue&type=style&index=0&id=99a3d4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a3d4ca",
  null
  
)

export default component.exports